export const CUSTOMIZATION_READ_REQUEST = 'customization read requested'
export const CUSTOMIZATION_READ_SUCCESS = 'customization read succeeced'
export const CUSTOMIZATION_READ_FAILURE = 'customization read failed'
// ==============API UPDATE OF CUSTOMIZATION ================
export const CUSTOMIZATION_UPDATE_REQUEST = 'customization update requested'
export const CUSTOMIZATION_UPDATE_SUCCESS = 'customization update succeeced'
export const CUSTOMIZATION_UPDATE_FAILURE = 'customization update failed'


export function customizationReadRequest(){
    return {
        type: CUSTOMIZATION_READ_REQUEST
    }
}
export function customizationReadSuccess(customization){
    return {
        type: CUSTOMIZATION_READ_SUCCESS,
        payload: customization
    }
}
export function customizationReadFailure(err, response){
    return {
        type: CUSTOMIZATION_READ_FAILURE,
        response: response
    }
}


export function customizationUpdateRequest(){
    return {
        type: CUSTOMIZATION_READ_REQUEST
    }
}
export function customizationUpdateSuccess(customization){
    return {
        type: CUSTOMIZATION_UPDATE_SUCCESS,
        payload: customization
    }
}
export function customizationUpdateFailure(err, response){
    return {
        type: CUSTOMIZATION_READ_FAILURE,
    }
}

//**************************************//
//***********OFFLINE SETTINGS***********//
//**************************************//

export const OFFLINE_SETTINGS_GET_REQUEST = 'offline settings get requested'
export const OFFLINE_SETTINGS_GET_SUCCESS = 'offline settings get succeeced'
export const OFFLINE_SETTINGS_GET_FAILURE = 'offline settings get failed'

export function offlineSettingsGetRequest(){
    return {
        type: OFFLINE_SETTINGS_GET_REQUEST
    }
}

export function offlineSettingsGetSuccess(payload){
    return {
        type: OFFLINE_SETTINGS_GET_SUCCESS,
        payload: payload
    }
}

export function offlineSettingsGetFailure(err, res){
    return {
        type: OFFLINE_SETTINGS_GET_FAILURE
    }
}



// WEBPACK FOOTER //
// ./src/model/Customization/actions.js